import strings from "strings";

const paymentTypeNames = strings.PAYMENTS_TYPES_NAMES;
const companyFormFields = {
  paymentTypesCheckbox: [
    {
      name: "hasFeatureEarnestMoney",
      label: paymentTypeNames.EARNEST_MONEY,
    },
    {
      name: "hasFeatureSecurityDeposit",
      label: paymentTypeNames.SECURITY_DEPOSIT,
    },
    {
      name: "hasFeatureCommission",
      label: paymentTypeNames.FEATURE_COMMISSION,
    },
    {
      name: "hasFeatureRentPayment",
      label: paymentTypeNames.RENT_PAYMENT,
    },
    {
      name: "hasFeatureHudEarnestMoney",
      label: paymentTypeNames.HUD_EARNEST_MONEY,
    },
    {
      name: "hasFeatureOther",
      label: paymentTypeNames.OTHER,
    },
    {
      name: "hasFeatureRemittance",
      label: paymentTypeNames.REMITTANCE,
    },
    {
      name: "hasFeatureClosingFunds",
      label: paymentTypeNames.CLOSING_FUNDS,
    },
    {
      name: "hasFeatureOptionFee",
      label: paymentTypeNames.OPTION_FEE,
    },
    {
      name: "hasFeatureEarnestMoneyPlusOption",
      label: paymentTypeNames.EARNEST_MONEY_PLUS_OPTION,
    },
    {
      name: "hasFeatureSurveyFees",
      label: paymentTypeNames.SURVEY_FEES,
    },
    {
      name: "hasFeatureInvoiceCollection",
      label: paymentTypeNames.INVOICE_COLLECTION,
    },
    {
      name: "hasFeatureClientPayment",
      label: paymentTypeNames.CLIENT_PAYMENT,
    },
    {
      name: "hasFeatureAgentFees",
      label: paymentTypeNames.AGENT_FEES,
    },
    {
      name: "hasFeatureHOA",
      label: paymentTypeNames.HOA,
    },
    {
      name: "hasFeatureLossDraft",
      label: paymentTypeNames.LOSS_DRAFT,
    },
  ],
  securityCheckbox: [
    {
      name: "require2FA",
      label: strings.REQUIRE_2FA,
    },
    {
      name: "hasMobile2FA",
      label: strings.MOBILE_2FA,
    },
    {
      name: "allowAppSignup",
      label: strings.ALLOW_APP_SIGNUP,
    },
  ],
};

export { companyFormFields };
